import React, { Component } from 'react';
import { connect } from 'react-redux';
import Helmet from 'react-helmet';
import { forEach, isEmpty } from 'lodash';

class AppHelmet extends Component {
    constructor(props) {
        super(props);
        this.state = {
            meta: [],
        };
    }

    componentWillMount() {
        // On server, set metadata
        if (typeof window === 'undefined') {
            this.setMetaData(this.props.siteInfo);

            // On client and meta not set (siteInfo populate on server, not local state not set)
        } else if (!!this.props.siteInfo.site && !this.state.meta.length) {
            this.setMetaData(this.props.siteInfo);
        }
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        // Only set meta tags, etc once
        if (nextProps.siteInfo.site && !this.state.meta.length) {
            this.setMetaData(nextProps.siteInfo);
        }
    }

    setMetaData(siteInfo) {
        console.log('is it repeating in setmetaData()?');
        // Get favicons
        let favicons = [];

        favicons.push(
            <meta
                key="application-name"
                name="application-name"
                content={siteInfo.site.title}
            />
        );

        if (!isEmpty(siteInfo.favicons)) {
            forEach(siteInfo.favicons.icons, (icon, i) => {
                if (icon.rel === 'apple-touch-icon') {
                    favicons.push(
                        <link
                            key={i}
                            rel={icon.rel}
                            sizes={icon.sizes}
                            href={icon.filename}
                        />
                    );
                } else if (icon.rel === 'icon') {
                    favicons.push(
                        <link
                            key={i}
                            rel={icon.rel}
                            type={icon.type}
                            sizes={icon.sizes}
                            href={icon.filename}
                        />
                    );
                } else if (icon.rel === 'manifest') {
                    favicons.push(<link key={i} rel={icon.rel} href={icon.filename} />);
                } else if (icon.rel === 'msapplication-TileImage') {
                    favicons.push(
                        <meta
                            key={`${i}-TileColor`}
                            name="msapplication-TileColor"
                            content={siteInfo.favicons.default_color}
                        />
                    );
                    favicons.push(
                        <meta
                            key={`${i}-TileImage`}
                            name="msapplication-TileImage"
                            content={icon.filename}
                        />
                    );
                } else if (icon.rel === 'mask-icon') {
                    favicons.push(
                        <link
                            key={i}
                            rel={icon.rel}
                            href={icon.filename}
                            color={siteInfo.favicons.default_color}
                        />
                    );
                }
            });

            favicons.push(
                <meta
                    key="theme-color"
                    name="theme-color"
                    content={siteInfo.favicons.default_color}
                />
            );
        }

        this.setState({ meta: favicons });
    }

    putHelmetOn() {
        console.log('is it repeating in puthelmeton()');
        // Get full url from client or server
        let fullURL = '';
        if (typeof window !== 'undefined') {
            fullURL =
                window.location.protocol +
                '//' +
                window.location.host +
                this.props.location.pathname;
        } else if (this.props.serverRequest) {
            const protocol = this.props.serverRequest.connection.encrypted
                ? 'https'
                : 'http';
            fullURL =
                protocol +
                '://' +
                this.props.serverRequest.headers.host +
                this.props.location.pathname;
        }

        const urlTag =
            fullURL === '' ? null : <meta property="og:url" content={fullURL} />;
        const linkTag = fullURL === '' ? null : <link rel="canonical" href={fullURL} />;

        let finalTitle = !!this.props.siteInfo.site ? this.props.siteInfo.site.title : '';
        if (this.props.pageTitle !== '') {
            if (finalTitle !== '') finalTitle += ' | ';
            finalTitle += this.props.pageTitle;
        }
        // const finalTitle = this.props.siteInfo.site.title

        // console.log('App title:', this.props.siteInfo.site ? this.props.siteInfo.site.title : '')

        return this.props.siteInfo.site;
        // ? (
        // 	<Helmet
        // 	// onChangeClientState={(newState) => console.log('Change app:', newState, 'Title: ' + this.props.siteInfo.site.title)}
        // 	>
        // 		<title>{finalTitle}</title>
        // 		<meta property="twitter:title" content={finalTitle} />
        // 		{urlTag}
        // 		{linkTag}
        // 		<meta property="og:title" content={finalTitle} />
        // 		<meta property="og:type" content="website" />
        // 		<meta property="og:description" content={finalTitle} />
        // 		{this.state.meta.map(icon => {
        // 			return icon;
        // 		})}
        // 	</Helmet>
        // ) : null;
    }

    render() {
        return this.putHelmetOn();
    }
}

const mapStateToProps = (state) => {
    return {
        siteInfo: state.siteInfo,
        pageTitle: state.siteInfo.pageTitle,
    };
};

export default connect(mapStateToProps)(AppHelmet);



// WEBPACK FOOTER //
// ./src/components/AppHelmet.js